<template>
	<div>
		<div v-if="!loading" layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc pb-2 pr1-mobile pl1-mobile bg-white" flex>
			<div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt2-pc mt1-mobile full-width">{{$t('surveys.the_answers')}}
				<span flex></span>
				<v-btn @click="exportCSV" :icon="$vuetify.breakpoint. smAndDown ? true : false" color="secondary" style="text-transform: none" depressed :small="$vuetify.breakpoint. smAndDown ? true : false" class="ma-0 pa0-mobile"><v-icon class="mr2-pc mr0-mobile">mdi-cloud-download</v-icon><span class="hidden-sm-and-down">{{$t('surveys.export')}}</span></v-btn>
			</div>

			<div v-if="pages && pages.length" layout="column" class="full-width">
				<v-expansion-panel v-for="(p,k) in pages" :key="p.id" :value="(k == 0) ? 0 : null" class="exp-ctn">
					<v-expansion-panel-content class="exp-header">
						<template slot="header">
								<div>{{i18n(p.title)}}</div>
						</template>
						<div v-for="q in p.questions" :key="'question2' + q.id" class="ml-2 mb-4" :style="(q.type == checkbox  || q.type == radio) ? '' : 'width: fit-content'">
							<div class="font-weight-bold mb-1">{{q.number}}. {{i18n(q.label)}}</div>
							<div v-if="q.type == checkbox  || q.type == radio" class="mt-2">
								<div v-for="o in q.options" :key="'option2_' + o.id" class="mb-2">
									<div layout="row" layout-align="start center">
										<div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 40 : 25">
											<v-progress-linear
												height="24"
												:value="o.stats"
												color="secondary"
												class="my-0"
											></v-progress-linear>
										</div>
										<div layout="column" class="ml-2" flex>
											{{i18n(o.label)}}
										</div>
									</div>
									<span class="grey--text">({{o.nb}}/{{q.total}} - {{o.stats.toFixed(2)}}%)</span>
								</div>
							</div>
							<div v-else>
								<div v-if="!q.is_required" class="caption grey--text">
									{{$t('surveys.opt_field_res')}} {{q.total}} {{$t('surveys.answers')}}
								</div>

								<v-pagination
									v-if="q.values.length > 4"
									v-model="q.page"
									:length="Math.ceil(q.values.length / 4)"
									:total-visible="5"
									color="secondary"
								></v-pagination>

								<div v-for="(v,i) in q.values" :key="'value2_' + i" v-if="i < (q.page * 4) && i >= ((q.page * 4) - 4)" style="white-space: pre-wrap; word-wrap: break-word;font-family: inherit;" class="mt-2 pa-1 mb-2" :class="[(i % 2) ? 'bg-white' : 'bg-transparent']">{{v}}</div>
							</div>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</div>
			<div v-else>
				<div v-for="q in questions" :key="'question_' + q.id" class="ml-2 mb-4" :style="(q.type == checkbox  || q.type == radio) ? '' : 'width: fit-content'">
					<div class="font-weight-bold mb-1">{{q.number}}. {{i18n(q.label)}}</div>
					<div v-if="q.type == checkbox  || q.type == radio" class="mt-2">
						<div v-for="o in q.options" :key="'option_'+o.id" class="mb-2">
							<div layout="row" layout-align="start center">
								<div layout="column" flex="25">
									<v-progress-linear
										height="24"
										:value="o.stats"
										color="secondary"
										class="my-0"
									></v-progress-linear>
								</div>
								<div layout="column" class="ml-2" flex>
									{{i18n(o.label)}}
								</div>
							</div>
							<span class="grey--text">({{o.nb}}/{{q.total}} - {{o.stats.toFixed(2)}}%)</span>
						</div>
					</div>
					<div v-else>
						<div v-if="!q.is_required" class="caption grey--text">
							{{$t('surveys.opt_field_res')}} {{q.total}} {{$t('surveys.answers')}}
						</div>

						<v-pagination
							v-if="q.values.length > 4"
							v-model="q.page"
							:length="Math.ceil(q.values.length / 4)"
							:total-visible="5"
							color="secondary"
						></v-pagination>

						<div v-for="(v,i) in q.values" :key="'value_' + i" v-if="i < (q.page * 4) && i >= ((q.page * 4) - 4)" style="white-space: pre-wrap; word-wrap: break-word;font-family: inherit;" class="mt-2 pa-1 mb-2" :class="[(i % 2) ? 'bg-white' : 'bg-transparent']">{{v}}</div>
					</div>
				</div>
			</div>
		</div>
		<div layout="row" class="bg-white" style="height: 100%" layout-align="center center" v-else>
				<v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
		</div>
	</div>
</template>
<script>
    import Consts from '@/consts'
    import I18nMixin from '@/mixins/i18n'
		import Surveys from '@/api/surveys'
		import moment from 'moment'

    export default {
        mixins: [I18nMixin],
        props: {
            survey: {
                required: true,
                type: Object,
                default () {
									return {message: {}};
								}
            }
        },
        data () {
            return {
							loading: false,
							pages: [],
							questions: []
            }
        },
        mounted () {
					this.fetch();
        },
        methods: {
					fetch(){
						this.loading = true;
						Surveys.answers(this.$route.params.id).then(res => {
							if(res.data.pages && res.data.pages.length){
								this.pages = res.data.pages;
							} else{
								this.questions = res.data.questions;
							}
							this.loading = false;
						});
					},
					exportCSV(){
                Surveys.export(this.$route.params.id).then(res => {
                    let blob = new Blob([res.data], {type: "octet/stream"});
                    let name = "Survey-" + this.i18n(this.survey.title).replace(/\s+/g, '-').toLowerCase() + "-answers-" + moment().format('YYYY-MM-DD-hh-mm-ss') + ".csv";

                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(blob, name);
                    } else{
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        let url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = name;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                })
            }
        },
        computed: {
					text(){
						return Consts.TEXT;
					},
					textarea(){
						return Consts.TEXTAREA;
					},
					checkbox(){
						return Consts.CHECKBOX;
					},
					radio(){
						return Consts.RADIO;
					},
        }
    }
</script>
<style>
.exp-header > .v-expansion-panel__header > div {
  margin-left: 5px;
  font-weight: bold;
  font-size: 1.25rem !important;
}
.exp-header
  > .v-expansion-panel__header
  > .v-expansion-panel__header__icon
  > .v-icon {
  position: absolute;
  left: 0;
  margin-left: 0px;
  margin-right: 5px;
  top: 12px;
  font-weight: bold;
}
.exp-ctn {
  box-shadow: none;
}
.exp-ctn > .v-expansion-panel__container.exp-header {
  background-color: unset;
}
</style>
<style scoped>
</style>